import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const CheckIcon: React.FC<IconProps> = ({
  className = '',
  style,
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls} style={style}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />

        <path
          fillRule="nonzero"
          d="M10.24 16.31 6 12.07l1.41-1.41 2.83 2.83L15.9 7.83l1.41 1.41-7.07 7.07Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default CheckIcon;
